<div class="daily-container">
  <p class="qingkuang">
    <span>日数据传输量</span>
  </p>
  <div class="daily-echarts" echarts [options]="chartOption" [autoResize]="true"></div>
</div>
